import { styled } from "styled-components";

import { Insta, Blog, Appstore, GooglePlay } from "src/assets/svgs";
import { cls } from "src/theme/colors";

import PersonalAiLogo from "src/assets/images/personalai_logo.png";

function Footer() {
  return (
    <S.Container>
      <S.Box>
        <S.Left>
          <a href="https://personalai.so" target="_blank" rel="noopener noreferrer">
            <S.Logo src={PersonalAiLogo} alt="Personal AI" />
          </a>
          <S.Middle>
            <p>서울 서초구 매헌로 16길 32 희경빌딩 F동 402호</p>
            <p>
              퍼스널에이아이(주) / 대표이사. 이재영 / <span>대표전화. 02-2038-2511 / 팩스. 050-7086-2235 /</span>{" "}
              <span>대표메일. hello@personalai.so</span>
            </p>
            <p>
              사업자번호. 889-87-01698 / <span>부가통신사업자. 제2-01-20-0274호 /</span>{" "}
              <span>통신판매업신고. 2020-서울성동-02763</span>
            </p>
            <br />
            <p>© 퍼스널에이아이. All rights reserved.</p>
            <br />
            {/* 앱마다 개인정보 처리방침이 따로 있어서, 어느 앱의 것인지 이름을 붙여 맨 아래 줄에 나란히 둔다. */}
            <S.Policies>
              <li>
                <a href="/documents/privacy_policy.html" target="_blank" rel="noopener noreferrer">
                  마이디 개인정보 처리방침
                </a>
              </li>
              <li>
                {/* 마이주식 처리방침은 주소에 버전(2.0)이 들어 있어서, 개정되면 이 주소도 함께 바꿔야 한다. */}
                <a href="https://myd-talk.web.app/privacy/2.0/" target="_blank" rel="noopener noreferrer">
                  마이주식 개인정보 처리방침
                </a>
              </li>
            </S.Policies>
          </S.Middle>
        </S.Left>
        <S.Right>
          <S.Social>
            <a href="https://www.instagram.com/my_d.official" target="_blank" rel="noopener noreferrer">
              <Insta />
            </a>
            <a href="https://blog.naver.com/mydworld" target="_blank" rel="noopener noreferrer">
              <Blog />
            </a>
            <a
              href="https://apps.apple.com/kr/app/%EB%A7%88%EC%9D%B4%EB%94%94/id1576612543"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Appstore />
            </a>
            <a
              href="https://play.google.com/store/apps/details?id=io.snplab.myd"
              target="_blank"
              rel="noopener noreferrer"
            >
              <GooglePlay />
            </a>
          </S.Social>
        </S.Right>
      </S.Box>
    </S.Container>
  );
}

export default Footer;

const S = {
  Container: styled.footer`
    background: #333333;
    width: 100%;
    height: 222px;
  `,
  Box: styled.div`
    width: calc(100% - 480px);
    padding-top: 56px;
    margin: 0 240px;
    display: flex;
    justify-content: space-between;
  `,
  Left: styled.div`
    display: flex;
    align-items: flex-start;
  `,
  Logo: styled.img`
    width: 152px;
    height: 36px;
  `,
  Middle: styled.div`
    color: white;
    font-size: 13px;
    margin-left: 120px;
    line-height: 15px;
    a {
      text-decoration: underline;
      color: white;
    }
  `,
  // 두 링크가 한 문장처럼 이어져 보이지 않도록 사이에 얇은 세로선을 두어 구분한다.
  Policies: styled.ul`
    display: flex;
    li + li {
      position: relative;
      /* 세로선(1px)의 양쪽을 12px씩 띄운다. */
      margin-left: 12px;
      padding-left: 13px;
      /* 세로선은 줄 높이(15px)가 아니라 글자가 놓이는 높이에 맞춰, 밑줄보다 위에서 끝나게 한다. */
      &::before {
        position: absolute;
        top: 3px;
        left: 0;
        width: 1px;
        height: 10px;
        background: ${cls.gray4};
        content: "";
      }
    }
  `,

  Right: styled.div``,
  Social: styled.div`
    display: flex;
    svg {
      margin-left: 24px;
    }
  `,
};
